const mobileMenu = () => {
  const mobileButton = document.querySelector('.c-navigation__mobile');
  mobileButton.addEventListener('click', () => {
    document.querySelector('html').classList.toggle('mobile-menu--active');
  });
};

export default mobileMenu;
